import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  return <AnimatePresence data-id="element-210">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/50 z-50 backdrop-blur-sm" data-id="element-211" />
          <motion.div initial={{
        opacity: 0,
        y: 100,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 100,
        scale: 0.95
      }} className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl bg-[#FDF8F0] rounded-2xl shadow-2xl z-50 max-h-[85vh] flex flex-col overflow-hidden" data-id="element-212">
            <div className="flex items-center justify-between p-6 border-b border-[#C8956C]/20" data-id="element-213">
              <h2 className="text-2xl font-heading font-bold text-[#3D2B1F]" data-id="element-214">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 hover:bg-[#FAF3E8] rounded-full transition-colors" aria-label="Cerrar modal" data-id="element-215">
                <XIcon className="w-6 h-6 text-[#3D2B1F]" data-id="element-216" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-[#5A4332] font-body text-sm md:text-base leading-relaxed" data-id="element-217">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}